import reframe from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';
import Immutable from 'immutable';
import * as services from '@/nikeone/services';
import { createClocksMap, pushEvent2ClocksMap } from '@/events/services/clocks';
import { addToRecentlyVisited, clearRecentlyVisisted, loadRecentlyVisited } from './localstorage';
import { denormalizeSportEventId } from '@/nikeone/domain/sportevent';
import { pushEvent2Map } from '@/events/services/events';
import { startClocks, stopClocks } from './clocks';

reframe.regEventFx('event:recently-visited.init', defaultMiddlewares, ({ db }) => {
    const recent = loadRecentlyVisited();
    return {
        // podmienene kvoli tomu aby itemy na v page history neblikli
        db: db.getIn(['recently-visited', 'events']) ? db : db.setIn(['recently-visited', 'events'], recent),
        'fx:recently-visited.load': { recent },
        'fx:recently-visited.start-clock': {}
    };
});

reframe.regFx(
    'fx:recently-visited.load',
    ({ recent }) =>
        recent.size &&
        services
            .loadSimpleSportEvents(recent.keySeq().toArray())
            .then(data => reframe.dispatch(['event:recently-visited.loaded', data]))
);
reframe.regFx('fx:recently-visited.start-clock', startClocks);

const parseBoxesData = data => {
    return Immutable.fromJS(data.sportEvents).reduce((acc, event) => {
        const sportEventId = denormalizeSportEventId(event.get('sportEventId')).toString();
        return acc.set(
            sportEventId,
            event
                .set('hasBoxesData', true)
                .set('id', sportEventId)
                .set('sportEventId', sportEventId)
        );
    }, Immutable.Map());
};

reframe.regEventFx('event:recently-visited.loaded', defaultMiddlewares, ({ db }, [data]) => {
    const sportEvents = parseBoxesData(data);
    return {
        db: db.mergeDeepIn(['recently-visited', 'events'], sportEvents)
    };
});

reframe.regEventFx('event:recently-visited.add', defaultMiddlewares, ({ db }, [recent]) => ({
    db: db.mergeDeepIn(
        ['recently-visited', 'events', denormalizeSportEventId(recent.get('sportEventId')).toString()],
        recent
    ),
    'fx:recently-visited.add': { recent }
}));

reframe.regEventFx('event:recently-visited.clear', defaultMiddlewares, ({ db }) => ({
    db: db.delete('recently-visited'),
    'fx:recently-visited.stop-clock': {},
    'fx:recently-visited.clear': {}
}));

reframe.regFx('fx:recently-visited.clear', clearRecentlyVisisted);

reframe.regFx('fx:recently-visited.add', ({ recent }) => addToRecentlyVisited(recent));

reframe.regEventDb('event:recently-visited.live.snapshot', defaultMiddlewares, (db, [snapshot]) => {
    const liveEvents = Immutable.fromJS(snapshot).reduce((acc, i) => {
        const id = denormalizeSportEventId(i.get('id')).toString();
        return acc.set(id, i.set('id', id).set('hasLiveData', true));
    }, Immutable.Map());

    return db
        .mergeDeepIn(['recently-visited', 'events'], liveEvents)
        .setIn(['recently-visited', 'clock'], createClocksMap(liveEvents));
});

reframe.regEventDb('event::recently-visited.live.message', defaultMiddlewares, (db, [data]) =>
    db
        .updateIn(['recently-visited', 'events'], Immutable.Map(), actualMap =>
            pushEvent2Map(
                actualMap,
                data,
                d => d,
                d => d
            )
        )
        .updateIn(['recently-visited', 'clock'], Immutable.Map(), actualMap => pushEvent2ClocksMap(actualMap, data))
);

reframe.regEventFx('event:recently-visited.end', defaultMiddlewares, ({ db }) => ({
    db: db.delete(['recently-visited']),
    'fx:recently-visited.stop-clock': {}
}));

reframe.regFx('fx:recently-visited.stop-clock', stopClocks);
